<app-common-bar> </app-common-bar>
<div class="cat__content">
  <router-outlet></router-outlet>
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <router-outlet *ngIf="!isIframe"></router-outlet>
  <app-footer></app-footer>
</div>
